
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'NoDataComponent',
  setup(props, { root }) {
    const navigateToHome = () => {
      root.$router.replace({ path: '/home', query: null });
    };

    return { navigateToHome };
  },
});
